<template>
  <cvc-card :failed="false" :loading="false" :skeleton-row-heights="[]" :skeleton-type-matrix="[]">
    <div class="d-flex py-4">
      <div class="notification-builder-form-wrapper">
        <notification-builder-form
          class="notification-builder-form mx-2"
          :brand="brand"
          @input="
            (event) => {
              this.profileAction = event;
            }
          "
        />
      </div>
      <div class="text-align-center mobile-view-wrapper">
        <mobile-view class="mobile-view mx-auto" :payload="payload" />
      </div>
    </div>
  </cvc-card>
</template>

<script>
import NotificationBuilderForm from "@/components/Notifications/NotificationBuilderForm";
import MobileView from "@/components/Notifications/MobileView";
import CvcCard from "@/components/CvcCard";

export default {
  name: "NotificationsBuilder",
  components: {CvcCard, MobileView, NotificationBuilderForm },
  data() {
    return {
      profileAction: {},
    };
  },
  computed: {
    payload() {
      return this.profileAction?.action?.payload ?? {};
    },
    brand() {
      return this.$store.state.dailyCounts.brand;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/_mixins.scss";

  .notification-builder-wrapper {
    background-color: #F7F7FC;
    margin: 0;
  }
  .notification-builder-form-wrapper {
    margin-left: 50px;
    margin-right: 50px;
    width: 50%;
  }
  .notification-builder-form {
    width: 100%;
  }
  .mobile-view-wrapper {
    margin: 42px auto;
  }
  .mobile-view {
    width: 401px;
  }
</style>
